import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { db } from '../../firebase';
import { doc, updateDoc } from "firebase/firestore";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Initial State
export const initialState = { 
    albums: [],
    toggle: false,
    addImageFormToggle: false,
    albumToggle: false,
    updateImgFormToggle: false,
    viewImageToggle: false,
    searchIconToggle: false, 
    searchedText: "",
    isInitialized: false,
    currentAlbumOBJ:  {},
    currImgCardUpdate: {},
    currImagesForSlides: [],
    currImgIdx: 0,
};

// Async Thunk Action Creators
export const updateImageInAlbum = createAsyncThunk(
    'albums/updateImageInAlbum',
    async (imageObj, { dispatch, getState }) => {
        console.log('updateImageInAlbum Thunk called and imageObj is: ',imageObj);
        try {
            const { currentAlbumOBJ } = getState().photofolioReducer;
            const albumId = currentAlbumOBJ.id;

            const updatedImages = currentAlbumOBJ.images.map((img, idx) => {
                if (imageObj.index !== null && imageObj.index === idx) {
                    return { text: imageObj.text, url: imageObj.url };
                } else {
                    return img;
                }
            });

            // Optimistically update the Redux state
            await dispatch(updateImageInAlbumSuccess({ updatedImages, albumId }));

            // Update document in Firestore
            await updateDoc(doc(db, 'albums', albumId), {
                images: updatedImages,
            });
            
            return {updatedImages, albumId};
        } catch (error) {
            dispatch(updateImageInAlbumFailure(error));
            throw error;
        }
    }
);

export const deleteImgfromAlbum = createAsyncThunk(
    'albums/deleteImgfromAlbum',
    async (index, { dispatch, getState }) => {
        console.log('deleteImgfromAlbum Thunk called and index is: ', index);
        try {
            const { currentAlbumOBJ } = getState().photofolioReducer;
            const albumId = currentAlbumOBJ.id;

            const updatedImages = currentAlbumOBJ.images.filter((img, idx) => idx !== index);
            
            await dispatch(deleteImgfromAlbumSuccess({ updatedImages, albumId })); 

            await updateDoc(doc(db, 'albums', albumId), {
                images: updatedImages,
            });

            return { albumId, updatedImages };

        } catch (error) {
            dispatch(deleteImgfromAlbumFailure(error)); // Dispatch the failure action
            throw error;
        }
    }
);



export const addNewImgToAlbum = createAsyncThunk(
    'albums/addNewImgToAlbum',
    async (imageOBJ, { dispatch, getState }) => {
        console.log('addNewImgToAlbum Thunk called and imageOBJ is: ', imageOBJ)
        try {
            const { currentAlbumOBJ } = getState().photofolioReducer;
            const albumId = currentAlbumOBJ.id;

            const updatedImages = [imageOBJ, ...currentAlbumOBJ.images];

            dispatch(addNewImgToAlbumSuccess({ updatedImages, albumId }));

            await updateDoc(doc(db, 'albums', albumId), {
                images: updatedImages,
            });
            return { updatedImages, albumId };

        } catch (error) {
            dispatch(addNewImgToAlbumFailure(error));
            throw error;
        }
    }
);

export const addAlbum = createAsyncThunk(
    'album/addAlbum', 
     async (newAlbum, {dispatch}) => {
        try {
            const docRef = await addDoc(collection(db, 'albums'), {
                ...newAlbum,
                createdAt: serverTimestamp(),
            });
            toast.success("Album created successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            });
        } catch (error) {
            console.error('Error adding album:', error);
            toast.error("Error creating album", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            });
        }
     }
);

// ****************************************************************************************** Reducers
const photoFolioSlice = createSlice({
    name: 'fotofolio',
    initialState,
    reducers: {
        searchedTextHandle: (state, action) => {
            console.log('searchedTextHandle text: ',action.payload)
            state.searchedText = action.payload;
            console.log('state.searchedText ',state.searchedText);
        },
        searchIconToggleHandle: (state, action) => {
            state.searchIconToggle = !state.searchIconToggle;
        },
        currImgIdxtoDispalayHandle: (state, action) => {
            console.log("currImgIdxtoDispalayHandle ",action.payload);
            state.currImgIdx = action.payload;
            console.log('state.currImgIdx ',state.currImgIdx);
        },
        currImagesForSlidesHandle: (state, action) => {
            const imagesUrls = action.payload.images.map( (imgObj) => imgObj.url );
            state.currImagesForSlides = imagesUrls;
        },
        currImgCardUpdateHandle: (state, action) => {
            state.currImgCardUpdate = action.payload;
        },
        setcurrentAlbumOBJ: (state, action) => {
            const album = state.albums.find( (album, idx) => idx === action.payload );
            state.currentAlbumOBJ = album;
            console.log('state.currentAlbumOBJ ',state.currentAlbumOBJ)
        },
        handleToggle: (state, action) => {
            console.log('state.toggle ',state.toggle);
            state.toggle = !state.toggle;
        },
        viewImageToggleHandle: (state, action) => {
            state.viewImageToggle = action.payload;
        },
        handleImageFormToggle: (state, action) => {
            state.addImageFormToggle = !state.addImageFormToggle;
        },
        handleImageFormToggleByArg: (state, action) => {
            console.log('handleImageFormToggleByArg called')
            state.addImageFormToggle = action.payload;
        },
        updateImgFormToggleHandle: (state, action) => {
            console.log("updateImgFormToggleHandle called");
            state.updateImgFormToggle = action.payload;
        },
        handleAlbumToggle: (state, action) => {
            state.albumToggle = !state.albumToggle;
            console.log('state.albumToggle ',state.albumToggle)
        },
        updateImageInAlbumSuccess: (state, action) => {
            const { updatedImages, albumId } = action.payload;
            state.albums = state.albums.map((album) => {
                if (album.id === albumId) {
                    return { ...album, images: updatedImages };
                }
                return album;
            });
            state.currentAlbumOBJ = { ...state.currentAlbumOBJ, images: updatedImages };

            toast.success("Image updated successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            })
        },
        updateImageInAlbumFailure: (state, action) => {
            console.log("updateImageInAlbumFailure called");
            toast.success("Error in updating image!", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            })
        },
        deleteImgfromAlbumSuccess: (state, action) => {
            const { updatedImages, albumId } = action.payload;
            state.albums = state.albums.map((album) => {
                if (album.id === albumId) {
                    return { ...album, images: updatedImages };
                }
                return album;
            });
            state.currentAlbumOBJ = { ...state.currentAlbumOBJ, images: updatedImages };

            toast.success("Image deleted successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            });
        },
        deleteImgfromAlbumFailure: (state, action) => {
            console.log("deleteImgfromAlbumFailure called");
            toast.error("Error in deleting image", {
                position: toast.POSITION.TOP_RIGHT,
                className: "toastMessage",
            });
        },
        addNewImgToAlbumSuccess: (state, action) => {
            const { updatedImages, albumId } = action.payload;
            state.albums = state.albums.map((album) => {
                if (album.id === albumId) {
                    return { ...album, images: updatedImages };
                }
                return album;
            });
            state.currentAlbumOBJ = { ...state.currentAlbumOBJ, images: updatedImages };

            toast.success('Image added successfully!', {
                position: toast.POSITION.TOP_RIGHT,
                className: 'toastMessage',
            });
        },
        addNewImgToAlbumFailure: (state, action) => {
            console.log("addNewImgToAlbumFailure called");
            toast.error('Error in adding image', {
                position: toast.POSITION.TOP_RIGHT,
                className: 'toastMessage',
            });
        },
        addAlbum: (state, action) => {
            state.albums = [...state.albums, action.payload]
        },
        setInitialAlbum: (state, action) => {
            state.albums = action.payload.map(album => ({
                ...album,
            }));

        },
        

    },

});

// Export Reducer and Actions
export const photofolioReducer = photoFolioSlice.reducer;
export const photofolioActions = photoFolioSlice.actions;
export const photofolioSelector = (state) => state.photofolioReducer;

export const {
    deleteImgfromAlbumSuccess, 
    deleteImgfromAlbumFailure,
    updateImageInAlbumSuccess,
    updateImageInAlbumFailure,
    addNewImgToAlbumSuccess,
    addNewImgToAlbumFailure
} = photofolioActions;
